"use client"

import { Component } from "react"
import routes from "../../routes/URL"
import API, { URL_PATH } from "../../services/API"
import redux from "../../common/Redux"
import Header from "../../components/Header"
import Toast from "../../components/Toast"
import noItemsImage from "../../assets/Group 48.svg"
import ConfirmationModal from "../../components/ConfirmationModal"

const ColorScheme = {
  buttonColor: "#FFC857",
  bgColor: "#02111B",
  componentColor: "#07070A",
  accentColor: "#BB0A21",
  textColor: "#FFFFFF",
}

class ListMenuScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      suppliers: [],
      isLoading: false,
      toast: {
        open: false,
        message: "",
        severity: "success",
      },
      page: 1,
      perPageItem: 10,
      totalItem: 0,
      totalPage: 1,
      search: "",
      isConfirmationModalOpen: false,
      itemToDelete: null,
    }
  }

  componentDidMount() {
    this.getSuppliers()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedHotelId?.id !== this.props.selectedHotelId?.id && this.props.selectedHotelId?.id) {
      this.getSuppliers()
    }
  }

  getSuppliers = async (page = 1) => {
    if (!this.props.selectedHotelId?.id) {
      this.showToast("Hotel ID is required", "error")
      return
    }

    this.setState({ isLoading: true })

    try {
      const params = {
        page,
        perPageItem: this.state.perPageItem,
        search: this.state.search,
      }

      const { status, message, data } = await API(
        this,
        "get",
        URL_PATH.getSuppliers(this.props.selectedHotelId.id),
        params,
      )

      if (status === "success") {
        this.setState({
          suppliers: data.data || data,
          totalItem: data.total || data.length,
          totalPage: data.totalPage || Math.ceil((data.total || data.length) / this.state.perPageItem),
          page: data.page || page,
          isLoading: false,
        })
      } else {
        this.showToast(message || "Failed to fetch suppliers", "error")
        this.setState({ isLoading: false })
      }
    } catch (error) {
      console.error("Error fetching suppliers:", error)
      this.showToast("An error occurred while fetching suppliers", "error")
      this.setState({ isLoading: false })
    }
  }

  handleSearchChange = (e) => {
    clearTimeout(this.timer)
    this.setState({ search: e.target.value }, () => {
      this.timer = setTimeout(() => this.getSuppliers(1), 550)
    })
  }

  handlePerPageChange = (e) => {
    this.setState({ perPageItem: e.target.value }, () => {
      this.getSuppliers(1)
    })
  }

  handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= this.state.totalPage) {
      this.setState({ page: pageNumber }, () => {
        this.getSuppliers(pageNumber)
      })
    }
  }

handleEdit = (supplier) => {
    this.props.history.push(routes.admin.supplier.update(supplier.id));
}

  openConfirmationModal = (item) => {
    this.setState({ isConfirmationModalOpen: true, itemToDelete: item })
  }

  closeConfirmationModal = () => {
    this.setState({ isConfirmationModalOpen: false, itemToDelete: null })
  }

  handleDeleteConfirmation = async () => {
    const { itemToDelete } = this.state
    if (itemToDelete) {
      try {
        const { status, message } = await API(this, "delete", `${URL_PATH.deleteSupplier}/${itemToDelete.id}`)

        if (status === "success") {
          this.showToast("Supplier deleted successfully", "success")
          this.getSuppliers(this.state.page)
        } else {
          this.showToast(message || "Failed to delete supplier", "error")
        }
      } catch (error) {
        console.error("Error deleting supplier:", error)
        this.showToast("An error occurred while deleting the supplier", "error")
      }
    }
    this.closeConfirmationModal()
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    })
  }

  handleToastClose = () => {
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }

  renderHeader = () => {
    const headers = [
      { title: "Supplier Name", key: "supplier_name", sortable: false },
      { title: "Contact Person", key: "contact_person", sortable: false },
      { title: "Phone", key: "phone", sortable: false },
      { title: "Email", key: "email", sortable: false },
      { title: "Actions", key: "action", sortable: false },
    ]

    return headers.map((item, index) => (
      <th
        key={index}
        style={{
          color: ColorScheme.textColor,
          borderBottom: `1px solid ${ColorScheme.buttonColor}`,
          padding: "1rem",
        }}
      >
        <div className="d-flex justify-content-between align-items-center">
          <span>{item.title}</span>
          {item.sortable && (
            <span
              style={{ cursor: "pointer" }}
              onClick={() => {
                this.setState({ orderBy: item.key, orderType: this.state.orderType === "asc" ? "desc" : "asc" }, () =>
                  this.getSuppliers(1),
                )
              }}
            >
              {this.state.orderBy === item.key ? (this.state.orderType === "asc" ? "▲" : "▼") : "◆"}
            </span>
          )}
        </div>
      </th>
    ))
  }

  renderEmptyState = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "40px 20px",
          minHeight: "300px",
          width: "100%",
          color: ColorScheme.textColor,
        }}
      >
        <img
          src={noItemsImage || "/placeholder.svg"}
          alt="No Items Available"
          style={{
            maxWidth: "200px",
            width: "100%",
            marginBottom: "20px",
          }}
        />
        <h4 style={{ color: ColorScheme.buttonColor, marginBottom: "10px", textAlign: "center" }}>
          No Suppliers Found
        </h4>
        <p style={{ textAlign: "center", maxWidth: "500px", color: "#999" }}>
          {this.state.search
            ? "No suppliers match your search criteria. Try adjusting your search terms."
            : "There are no suppliers to display. Suppliers will appear here once they are added."}
        </p>
      </div>
    )
  }

  renderActions = (item) => {
    return (
      <div className="d-flex align-items-center h-100 justify-content-center gap-2">
        <button
          className="btn btn-sm me-2 d-flex align-items-center"
          style={{
            backgroundColor: ColorScheme.buttonColor,
            color: ColorScheme.componentColor,
          }}
          onClick={() => this.handleEdit(item)}
        >
          <i className="fa fa-pencil me-1" aria-hidden="true"></i> EDIT
        </button>
        <button
          className="btn btn-sm d-flex align-items-center"
          style={{
            backgroundColor: ColorScheme.accentColor,
            color: ColorScheme.textColor,
          }}
          onClick={() => this.openConfirmationModal(item)}
        >
          <i className="fa fa-trash me-1" aria-hidden="true"></i> DELETE
        </button>
      </div>
    )
  }

  render() {
    const { suppliers, isLoading, toast, page, totalPage } = this.state
    const hasData = suppliers.length > 0

    return (
      <div
        style={{
          backgroundColor: ColorScheme.bgColor,
          minHeight: "100vh",
          color: ColorScheme.textColor,
          padding: "2rem",
          width:"-webkit-fill-available"
        }}
      >
        {/* Header Section */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <Header title="Suppliers" color={ColorScheme.textColor} />
          <div className="d-flex align-items-center gap-3">
            <div className="position-relative">
              <input
                type="text"
                className="form-control"
                placeholder="Search suppliers..."
                style={{
                  backgroundColor: "transparent",
                  color: ColorScheme.textColor,
                  boxShadow: "none",
                  paddingRight: "2.5rem",
                }}
                value={this.state.search}
                onChange={this.handleSearchChange}
                disabled={isLoading}
              />
              <i
                className="fa fa-search position-absolute"
                style={{ right: "1rem", top: "50%", transform: "translateY(-50%)" }}
              ></i>
            </div>
            <button
              className="btn"
              style={{
                backgroundColor: ColorScheme.buttonColor,
                color: "#000",
                fontWeight: 700,
                padding: "10px 20px",
                borderRadius: "6px",
                cursor: "pointer",
              }}
              onClick={() => {
                this.props.history.push(routes.admin.supplier.create)
              }}
            >
              + ADD SUPPLIER
            </button>
          </div>
        </div>

        {/* Per Page Selector - Only show when there's data */}
        {hasData && (
          <div className="d-flex justify-content-start align-items-center mb-4">
            <div className="d-flex align-items-center">
              <select
                className="form-select me-3"
                style={{
                  backgroundColor: "#02111B",
                  color: ColorScheme.textColor,
                  boxShadow: "none",
                }}
                value={this.state.perPageItem}
                onChange={this.handlePerPageChange}
              >
                {[5, 10, 15, 25, 50, 100].map((num) => (
                  <option key={num} value={num}>
                    {num} per page
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}

        {/* Table Container */}
        <div
          style={{
            backgroundColor: "#02111B",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
           
          }}
        >
          {isLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border" role="status" style={{ color: ColorScheme.buttonColor }}>
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : hasData ? (
            <>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>{this.renderHeader()}</tr>
                  </thead>
                  <tbody>
                    {suppliers.map((supplier, index) => (
                      <tr
                        key={supplier.id}
                        style={{
                          backgroundColor: index % 2 === 0 ? "transparent" : "#041A29",
                          borderBottom: "none",
                        }}
                      >
                        <td style={{ padding: "1rem", border: "none", verticalAlign: "middle", height: "80px" }}>
                          <div className="d-flex align-items-center h-100">{supplier.supplier_name}</div>
                        </td>
                        <td style={{ padding: "1rem", border: "none", verticalAlign: "middle", height: "80px" }}>
                          <div className="d-flex align-items-center h-100">{supplier.contact_person}</div>
                        </td>
                        <td style={{ padding: "1rem", border: "none", verticalAlign: "middle", height: "80px" }}>
                          <div className="d-flex align-items-center h-100">{supplier.phone}</div>
                        </td>
                        <td style={{ padding: "1rem", border: "none", verticalAlign: "middle", height: "80px" }}>
                          <div className="d-flex align-items-center h-100">{supplier.email}</div>
                        </td>
                        <td
                          style={{
                            padding: "1rem",
                            border: "none",
                            verticalAlign: "middle",
                            textAlign: "center",
                            height: "80px",
                          }}
                        >
                          {this.renderActions(supplier)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              {totalPage > 0 && (
                <div className="row mt-3">
                  <div className="col-12 col-md-6 mb-2 mb-md-0">
                    <div className="text-muted">
                      Showing {suppliers.length > 0 ? (page - 1) * this.state.perPageItem + 1 : 0}
                      {" to "}
                      {Math.min(page * this.state.perPageItem, this.state.totalItem)}
                      of {this.state.totalItem} entries
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <nav aria-label="Page navigation">
                      <ul className="pagination pagination-sm justify-content-md-end justify-content-center mb-0">
                        <li className={`page-item ${page <= 1 ? "disabled" : ""}`}>
                          <button
                            className="page-link"
                            onClick={() => this.handlePageChange(page - 1)}
                            disabled={page <= 1}
                            style={{
                              backgroundColor: page <= 1 ? "#6c757d" : ColorScheme.buttonColor,
                              color: page <= 1 ? "#fff" : ColorScheme.componentColor,
                              border: "none",
                            }}
                          >
                            Previous
                          </button>
                        </li>

                        {/* Show first page */}
                        {page > 3 && (
                          <li className="page-item">
                            <button
                              className="page-link"
                              onClick={() => this.handlePageChange(1)}
                              style={{
                                backgroundColor: ColorScheme.componentColor,
                                color: ColorScheme.textColor,
                                border: "none",
                              }}
                            >
                              1
                            </button>
                          </li>
                        )}

                        {/* Show ellipsis if needed */}
                        {page > 4 && (
                          <li className="page-item disabled">
                            <span className="page-link">...</span>
                          </li>
                        )}

                        {/* Show current page and surrounding pages */}
                        {Array.from({ length: Math.min(5, totalPage) }, (_, i) => {
                          let pageNum
                          if (totalPage <= 5) {
                            pageNum = i + 1
                          } else if (page <= 3) {
                            pageNum = i + 1
                          } else if (page >= totalPage - 2) {
                            pageNum = totalPage - 4 + i
                          } else {
                            pageNum = page - 2 + i
                          }

                          return (
                            <li key={pageNum} className={`page-item ${page === pageNum ? "active" : ""}`}>
                              <button
                                className="page-link"
                                onClick={() => this.handlePageChange(pageNum)}
                                style={{
                                  backgroundColor:
                                    page === pageNum ? ColorScheme.buttonColor : ColorScheme.componentColor,
                                  color: page === pageNum ? ColorScheme.componentColor : ColorScheme.textColor,
                                  border: "none",
                                }}
                              >
                                {pageNum}
                              </button>
                            </li>
                          )
                        })}

                        {/* Show ellipsis if needed */}
                        {page < totalPage - 3 && (
                          <li className="page-item disabled">
                            <span className="page-link">...</span>
                          </li>
                        )}

                        {/* Show last page if needed */}
                        {page < totalPage - 2 && (
                          <li className="page-item">
                            <button
                              className="page-link"
                              onClick={() => this.handlePageChange(totalPage)}
                              style={{
                                backgroundColor: ColorScheme.componentColor,
                                color: ColorScheme.textColor,
                                border: "none",
                              }}
                            >
                              {totalPage}
                            </button>
                          </li>
                        )}

                        <li className={`page-item ${page >= totalPage ? "disabled" : ""}`}>
                          <button
                            className="page-link"
                            onClick={() => this.handlePageChange(page + 1)}
                            disabled={page >= totalPage}
                            style={{
                              backgroundColor: page >= totalPage ? "#6c757d" : ColorScheme.buttonColor,
                              color: page >= totalPage ? "#fff" : ColorScheme.componentColor,
                              border: "none",
                            }}
                          >
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              )}
            </>
          ) : (
            this.renderEmptyState()
          )}
        </div>

        <ConfirmationModal
          isOpen={this.state.isConfirmationModalOpen}
          onConfirm={this.handleDeleteConfirmation}
          onCancel={this.closeConfirmationModal}
          title="Confirm Deletion"
          message="Are you sure you want to delete this supplier?"
          confirmText="Yes, delete it!"
          cancelText="Cancel"
        />

        <Toast
          open={toast.open}
          message={toast.message}
          severity={toast.severity}
          handleClose={this.handleToastClose}
        />
      </div>
    )
  }
}

export default redux(ListMenuScreen)
